import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, IconButton, Typography, Collapse } from '@material-ui/core';
import useAddCourseHook from './useAddCourseHook';
import { withStyles } from '@material-ui/core/styles';
import styles from './add-course.style';
import CloseIcon from '@mui/icons-material/Close';
import FormControl from '@material-ui/core/FormControl';
import { Autocomplete, DraggableTile } from '@orijinworks/frontend-commons';
import { CONTENT_DELIVERY_METHOD } from '../../../../../../services/constants';

const AddCourse = ({ classes, formData, handleCourseChange }) => {
  const {
    addCourseClick,
    showSearchSection,
    hideSearchSection,
    searchValue,
    handleSearchChange,
    isLoading,
    options,
    addSelectedCourse,
    draggableItems,
    contentDeliveryMethodError,
    handleDragComplete
  } = useAddCourseHook(formData, handleCourseChange);

  return (
    <div>
      <Typography
        variant="h4"
        color="primary"
        className={classes.title}
        component="h1"
        data-testid="program-courses-title"
      >
        Program Courses
      </Typography>

      <Typography variant="subtitle2" color="textSecondary" className={classes.fieldLabel}>
        Course List
      </Typography>

      <Typography variant="caption" color="textSecondary" className={classes.characterLimit}>
        A program must contain at least one course to be saved. Courses will display in the program catalog in the order
        listed below.
      </Typography>

      {draggableItems.length > 0 && (
        <DraggableTile
          itemsList={draggableItems} onDragComplete={handleDragComplete}
        />
      )}

      <Collapse in={showSearchSection} timeout={300}>
        <Box className={classes.searchCoursesSection}>
          <Box paddingTop="24px" paddingBottom="12px">
            <Box display="flex" gap="12px">
              <FormControl sx={{ paddingBottom: '12px' }} fullWidth>
                <Autocomplete
                  id="search-courses-select"
                  label="Search ID Course"
                  fullWidth
                  freeSolo={true}
                  error={Boolean(contentDeliveryMethodError)}
                  inputValue={searchValue?.label || ''}
                  onChange={(event, value) => handleSearchChange(value, 'select')}
                  onInputChange={(event, newValue, reason) => handleSearchChange(newValue, 'input')}
                  options={options}
                  disabled={isLoading}
                  loading={isLoading}
                  open={isLoading || options.length > 0}
                  testId="search-courses-input"
                  getOptionLabel={(option) => option.label || ''}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <Box display="flex" flexDirection="column">
                        <Typography variant="body1">{option.label}</Typography>
                        <Typography variant="caption" color="textSecondary">
                          {[CONTENT_DELIVERY_METHOD.D2L, CONTENT_DELIVERY_METHOD.CANVAS].includes(formData.contentDeliveryMethod)
                            ? option.externalId
                            : option.description}
                        </Typography>
                      </Box>
                    </li>
                  )}
                  filterOptions={(options) => options}
                />
                {contentDeliveryMethodError && (
                  <Typography variant="caption" color="textSecondary">
                    Please select Content Delivery Method and Content Provider in order to search the courses.
                  </Typography>
                )}
              </FormControl>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="92px"
                height="40px"
                gap="12px"
              >
                <IconButton
                  id="add-course-to-list"
                  className={classes.addCourseRoundButton}
                  disabled={!searchValue?.label?.trim()}
                  onClick={addSelectedCourse}
                >
                  <AddIcon fontSize="small" className={classes.addIcon} />
                </IconButton>
                <IconButton
                  aria-label="Cancel"
                  onClick={hideSearchSection}
                  disabled={false}
                  data-testid="cancel-button"
                >
                  <CloseIcon className={classes.cancelCourseRoundButton} />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Collapse>

      <div>
        <Button
          id="add-course-btn"
          data-testid="add-course-btn"
          variant="outlined"
          aria-label="Add Course"
          className={classes.addCourseButton}
          startIcon={<AddIcon />}
          onClick={addCourseClick}
          disabled={showSearchSection}
        >
          Add Course
        </Button>
      </div>
    </div>
  );
};
export default withStyles(styles)(AddCourse);
